import { notification } from "antd";
import { useState, useCallback } from "react";
import { SubmitHandler } from "react-hook-form";
import dayjs from "dayjs";
import { SchemaFormExtraction } from "../../../../features/forms/schemas/schemaFormExtraction";
import { useAppSelector } from "../../../redux-store/hooks";
import config from "../../../../config";

export const useExtractionDownload = () => {
  const accessToken = useAppSelector((state) => state.auth.user?.access_token);
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadExtraction: SubmitHandler<SchemaFormExtraction> = useCallback(
    async (values) => {
      setIsDownloading(true);
      try {
        const dateFrom = dayjs(values.dateFrom).format("YYYY-MM-DD");
        const dateTo = dayjs(values.dateTo).format("YYYY-MM-DD");
        const url = `${config.apiUrl}/evt/extractions/events?date_from=${dateFrom}&date_to=${dateTo}&export_format=${values.format}`;

        const response = await fetch(url, {
          headers: {
            Authorization: `Bearer ${accessToken ?? ""}`,
          },
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => null);
          throw new Error(errorData?.error || `Erreur ${response.status}`);
        }

        const blob = await response.blob();
        const objectUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = objectUrl;
        link.download = `evenements_${dateFrom}_${dateTo}.${values.format}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(objectUrl);

        notification.success({
          message: "Extraction rÃ©ussie",
          description: `Le fichier ${values.format.toUpperCase()} a Ã©tÃ© tÃ©lÃ©chargÃ©.`,
        });
      } catch (e: unknown) {
        const message =
          e instanceof Error ? e.message : "Une erreur est survenue";
        notification.error({
          message: "Ãchec de l'extraction",
          description: message,
        });
      } finally {
        setIsDownloading(false);
      }
    },
    [accessToken],
  );

  return { downloadExtraction, isDownloading };
};
